import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let SmithchartSeriesCollectionDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-seriesCollection';
        }
    }
});
export const SmithchartSeriesCollectionPlugin = {
    name: 'e-seriesCollection',
    install(Vue) {
        Vue.component(SmithchartSeriesCollectionPlugin.name, SmithchartSeriesCollectionDirective);
    }
};
export let SmithchartSeriesDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-series';
        }
    }
});
export const SmithchartSeriesPlugin = {
    name: 'e-series',
    install(Vue) {
        Vue.component(SmithchartSeriesPlugin.name, SmithchartSeriesDirective);
    }
};
